import { getData } from "country-list";
const HOME_NATIONS = [
    {
        code: "GB-ENG",
        name: "England",
        emoji: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    },
    {
        code: "GB-SCT",
        name: "Scotland",
        emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    },
    {
        code: "GB-WLS",
        name: "Wales",
        emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    },
];
export const countries = [...HOME_NATIONS, ...getData()].sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
export const countryCodeToEmoji = (countryCode) => {
    return (HOME_NATIONS.find((o) => o.code === countryCode)?.emoji ||
        String.fromCodePoint(...[...countryCode.toUpperCase()].map((char) => char.charCodeAt(0) + 127397)));
};
